"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HelpTopics = exports.default = void 0;

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _decorators = require("decorators");

var _react = _interopRequireWildcard(require("react"));

var _formatters = require("formatters");

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _SiteLayout = babelHelpers.interopRequireDefault(require("layouts/SiteLayout"));

var _base = babelHelpers.interopRequireDefault(require("block/base"));

var _base2 = require("modals/base");

var _class, _descriptor, _class3, _descriptor2, _class5, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _class7, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _class9, _descriptor15, _descriptor16, _descriptor17, _class11, _descriptor18;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || babelHelpers.typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = babelHelpers.getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = babelHelpers.getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return babelHelpers.possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var HelpTopicsPage = (_class11 = /*#__PURE__*/function (_Component6) {
  babelHelpers.inherits(HelpTopicsPage, _Component6);

  var _super7 = _createSuper(HelpTopicsPage);

  function HelpTopicsPage() {
    var _this7;

    babelHelpers.classCallCheck(this, HelpTopicsPage);

    for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    _this7 = _super7.call.apply(_super7, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this7, "content", _descriptor18, babelHelpers.assertThisInitialized(_this7));
    return _this7;
  }

  babelHelpers.createClass(HelpTopicsPage, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        id: "page-content-container"
      }, /*#__PURE__*/_react.default.createElement(HelpTopics, this.content));
    }
  }]);
  return HelpTopicsPage;
}(_react.Component), (_descriptor18 = babelHelpers.applyDecoratedDescriptor(_class11.prototype, "content", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class11);
exports.default = HelpTopicsPage;
var HelpTopics = (_class = /*#__PURE__*/function (_Component) {
  babelHelpers.inherits(HelpTopics, _Component);

  var _super = _createSuper(HelpTopics);

  function HelpTopics() {
    var _this;

    babelHelpers.classCallCheck(this, HelpTopics);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this, "topics", _descriptor, babelHelpers.assertThisInitialized(_this));
    return _this;
  }

  babelHelpers.createClass(HelpTopics, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "block stack header-block",
        "data-block-type": "header",
        "data-block-id": "helpHeader"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "spotlight-header variable-background",
        style: _base.default.styleForBackgroundObject({
          landscape: '/images/prositebgdefault1400x900.jpg',
          portrait: '/images/prositebgdefault1400x900.jpg',
          imageOverlay: 'none'
        })
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "inner-content animate-fadeIn"
      }, /*#__PURE__*/_react.default.createElement("h1", null, "Help & Support"), /*#__PURE__*/_react.default.createElement("h2", null, "Get answers to your questions about this site and managing your account")))), /*#__PURE__*/_react.default.createElement("div", {
        className: "block stack block-container height-auto",
        "data-block-id": "helpContentContainer",
        "data-block-type": "container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "block stack link-list height-auto",
        "data-block-id": "helpContentList",
        "data-block-type": "helpContentList"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "inner-content"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "container"
      }, /*#__PURE__*/_react.default.createElement("h1", {
        style: {
          color: 'rgb(85, 85, 85)'
        }
      }, "How-To's")), /*#__PURE__*/_react.default.createElement(HelpTopicsList, {
        topics: this.topics
      })))), /*#__PURE__*/_react.default.createElement("div", {
        className: "block stack text height-auto",
        "data-block-id": "helpContentText",
        "data-block-type": "freeform"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "inner-content container"
      }, /*#__PURE__*/_react.default.createElement("h1", null, "Still have questions?"), /*#__PURE__*/_react.default.createElement("p", null, "We are here to provide you with the assistance that you need."), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, "During business hours:"), /*#__PURE__*/_react.default.createElement("br", null), "Monday - Friday 9am-6pm", /*#__PURE__*/_react.default.createElement("span", {
        className: "desktop"
      }, ' and '), /*#__PURE__*/_react.default.createElement("span", {
        className: "mobile"
      }, /*#__PURE__*/_react.default.createElement("br", null)), "Saturday 9am-5pm", /*#__PURE__*/_react.default.createElement("br", null), "Contact us by email: ", /*#__PURE__*/_react.default.createElement("a", {
        href: "mailto:info@thepoolandspahouse.com",
        target: "_blank"
      }, "info@thepoolandspahouse.com"), /*#__PURE__*/_react.default.createElement("br", null), "Contact us by phone: 503-906-8148"), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, "After-hours and holidays:"), /*#__PURE__*/_react.default.createElement("br", null), "Contact us by email:", /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("a", {
        href: "mailto:fino@thepoolandspahouse.com",
        target: "_blank"
      }, "info@thepoolandspahouse.com")))));
    }
  }]);
  return HelpTopics;
}(_react.Component), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "topics", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.HelpTopics = HelpTopics;
var HelpTopicsList = (_class3 = /*#__PURE__*/function (_Component2) {
  babelHelpers.inherits(HelpTopicsList, _Component2);

  var _super2 = _createSuper(HelpTopicsList);

  function HelpTopicsList() {
    var _this2;

    babelHelpers.classCallCheck(this, HelpTopicsList);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this2, "topics", _descriptor2, babelHelpers.assertThisInitialized(_this2));
    return _this2;
  }

  babelHelpers.createClass(HelpTopicsList, [{
    key: "render",
    value: function render() {
      if (!this.topics.length) {
        return /*#__PURE__*/_react.default.createElement("p", {
          style: {
            fontStyle: 'italic',
            textAlign: 'center'
          }
        }, "There are no help topics");
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "card-container card-list"
      }, this.topics.map(function (topic) {
        return /*#__PURE__*/_react.default.createElement(Topic, _extends({
          key: topic.id
        }, topic));
      }));
    }
  }]);
  return HelpTopicsList;
}(_react.Component), (_descriptor2 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "topics", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
})), _class3);
var Topic = (_class5 = /*#__PURE__*/function (_Component3) {
  babelHelpers.inherits(Topic, _Component3);

  var _super3 = _createSuper(Topic);

  function Topic() {
    var _this3;

    babelHelpers.classCallCheck(this, Topic);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this3 = _super3.call.apply(_super3, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this3, "title", _descriptor3, babelHelpers.assertThisInitialized(_this3));
    babelHelpers.initializerDefineProperty(_this3, "image", _descriptor4, babelHelpers.assertThisInitialized(_this3));
    babelHelpers.initializerDefineProperty(_this3, "summary", _descriptor5, babelHelpers.assertThisInitialized(_this3));
    babelHelpers.initializerDefineProperty(_this3, "details", _descriptor6, babelHelpers.assertThisInitialized(_this3));
    babelHelpers.initializerDefineProperty(_this3, "contents", _descriptor7, babelHelpers.assertThisInitialized(_this3));
    babelHelpers.initializerDefineProperty(_this3, "id", _descriptor8, babelHelpers.assertThisInitialized(_this3));
    return _this3;
  }

  babelHelpers.createClass(Topic, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "card",
        onClick: this.show,
        style: {
          cursor: 'pointer'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "card product topic-item"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "top"
      }, /*#__PURE__*/_react.default.createElement("a", {
        className: "image",
        style: {
          backgroundImage: "url(/t/width=400/scale/f".concat(this.image, "/image.jpg)")
        },
        href: "javascript:void(0)"
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "middle without-bottom"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "inner-content"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: "javascript:void(0)"
      }, /*#__PURE__*/_react.default.createElement("h3", null, this.title)), /*#__PURE__*/_react.default.createElement("p", null, this.summary)))));
    }
  }, {
    key: "show",
    value: function show() {
      var modal = new HelpTopicModal(this.props);
      modal.show();
    }
  }]);
  return Topic;
}(_react.Component), (_descriptor3 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "title", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "image", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "summary", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "details", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "contents", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "id", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "show", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "show"), _class5.prototype)), _class5);

var HelpTopicModal = /*#__PURE__*/function (_ReactModal) {
  babelHelpers.inherits(HelpTopicModal, _ReactModal);

  var _super4 = _createSuper(HelpTopicModal);

  function HelpTopicModal(props) {
    var _this4;

    babelHelpers.classCallCheck(this, HelpTopicModal);
    _this4 = _super4.call(this);
    _this4.removeOnHide = true;
    _this4.useReactContainer = false;

    _this4.classList.push('help-topic-modal');

    _this4.setComponent( /*#__PURE__*/_react.default.createElement(TopicDetails, props));

    return _this4;
  }

  babelHelpers.createClass(HelpTopicModal, [{
    key: "title",
    get: function get() {
      return 'Help Topic';
    }
  }, {
    key: "icon",
    get: function get() {
      return "<span class='material-icons' data-icon='question_mark'></span>";
    }
  }]);
  return HelpTopicModal;
}(_base2.ReactModal);

var TopicDetails = (_class7 = /*#__PURE__*/function (_Component4) {
  babelHelpers.inherits(TopicDetails, _Component4);

  var _super5 = _createSuper(TopicDetails);

  function TopicDetails() {
    var _this5;

    babelHelpers.classCallCheck(this, TopicDetails);

    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    _this5 = _super5.call.apply(_super5, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this5, "title", _descriptor9, babelHelpers.assertThisInitialized(_this5));
    babelHelpers.initializerDefineProperty(_this5, "image", _descriptor10, babelHelpers.assertThisInitialized(_this5));
    babelHelpers.initializerDefineProperty(_this5, "summary", _descriptor11, babelHelpers.assertThisInitialized(_this5));
    babelHelpers.initializerDefineProperty(_this5, "details", _descriptor12, babelHelpers.assertThisInitialized(_this5));
    babelHelpers.initializerDefineProperty(_this5, "contents", _descriptor13, babelHelpers.assertThisInitialized(_this5));
    babelHelpers.initializerDefineProperty(_this5, "id", _descriptor14, babelHelpers.assertThisInitialized(_this5));
    return _this5;
  }

  babelHelpers.createClass(TopicDetails, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "topic-container"
      }, /*#__PURE__*/_react.default.createElement("h1", null, this.title), this.details && /*#__PURE__*/_react.default.createElement("div", {
        className: "details",
        dangerouslySetInnerHTML: {
          __html: this.details.indexOf('<') == -1 ? "<p>".concat(this.details, "</p>") : this.details
        }
      }), this.contents.map(function (node) {
        return /*#__PURE__*/_react.default.createElement(TopicImage, _extends({
          key: node.id
        }, node));
      }));
    }
  }]);
  return TopicDetails;
}(_react.Component), (_descriptor9 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "title", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "image", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "summary", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "details", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "contents", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "id", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class7);
var TopicImage = (_class9 = /*#__PURE__*/function (_Component5) {
  babelHelpers.inherits(TopicImage, _Component5);

  var _super6 = _createSuper(TopicImage);

  function TopicImage() {
    var _this6;

    babelHelpers.classCallCheck(this, TopicImage);

    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    _this6 = _super6.call.apply(_super6, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this6, "title", _descriptor15, babelHelpers.assertThisInitialized(_this6));
    babelHelpers.initializerDefineProperty(_this6, "image", _descriptor16, babelHelpers.assertThisInitialized(_this6));
    babelHelpers.initializerDefineProperty(_this6, "details", _descriptor17, babelHelpers.assertThisInitialized(_this6));
    return _this6;
  }

  babelHelpers.createClass(TopicImage, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "topic-image"
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: this.image
      }), /*#__PURE__*/_react.default.createElement("h2", null, this.title), this.details && /*#__PURE__*/_react.default.createElement("div", {
        className: "details",
        dangerouslySetInnerHTML: {
          __html: this.details.indexOf('<') == -1 ? "<p>".concat(this.details, "</p>") : this.details
        }
      }));
    }
  }]);
  return TopicImage;
}(_react.Component), (_descriptor15 = babelHelpers.applyDecoratedDescriptor(_class9.prototype, "title", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = babelHelpers.applyDecoratedDescriptor(_class9.prototype, "image", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = babelHelpers.applyDecoratedDescriptor(_class9.prototype, "details", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class9);